import { BaseDocumentApi } from './api.base';


export class BoxDocumentApi extends BaseDocumentApi {
}
